<div class="container-select-course">
    <div class="container">
        <div class="container-select-course__title">
            <h2 class="text-brand-10 ls-h2-section-title">{{"BLOCK.VIEW_SELECT_COURSE.WHAT_STUDY" | translate}}</h2>
            <p class="text-neutral-40 ls-p">{{"BLOCK.VIEW_SELECT_COURSE.SEARCH_COURSE_OR_POST_GRADUATE" | translate}}</p>
        </div>
        <div
            class="container-select-course__container-filter d-flex flex-wrap flex-lg-nowrap justify-content-center align-items-center">
            <div class="container-select-course__container-filter__box-item col-12 {{ colString }}"
                *ngFor="let item of arrayData; let idx = index;">
                <app-sample-select [block]="item" (valueForm)="valueEmitCheckbox($event)"
                    [resetValueCheckbox]="resetValueCheckbox"
                    [positionBlock]="{actualPosition: idx, lastOfIndex: arrayData.length - 1}"></app-sample-select>
            </div>
        </div>
        <div class="container-select-course__cta d-flex justify-content-center align-items-center">
            <button class="btn btn-success ls-label-medium-semibold" (click)="searchCourses()">{{"BLOCK.VIEW_SELECT_COURSE.SEARCH_COURSE" | translate}}</button>
        </div>
    </div>
</div>